'use strict';

const template   = require('commons/templates/Main.ejs');
const navMenuTpl = require('../templates/NavMenu.ejs');
const tooltip    = require('helpers/tooltip');

module.exports = Backbone.View.extend({
    el:      '.content',
    childEl: '#main-area',

    initialize: function() {
        this.render();
    },

    render: function() {
        const id = app.user.get('mppAdminId');
        const logoUrl = app.user.getLogoUrl(id);
        this.$el.html(template({
            navMenu:    navMenuTpl({
                userName: app.user.get('name'),
                role: app.user.get('role')
            }),
            headerMenu: null,
            version:    app.version,
            whitelabel: app.user.get('plan') !== 'client',
            logoUrl: logoUrl
        }));

        $('body').removeClass('gray-bg');

        this.$el.find('.logo img')
            .on('load', (e) => {
                $(e.target.parentElement).removeClass('hidden');
            })
            .on('error', (e) => {
                e.target.src = '';
            });

        tooltip.initBody();
    },

    setActiveLink: function(route) {
        this.$el.find('#side-menu li').removeClass('active');

        this.$el.find('#side-menu a[href="#' + route + '"]').parent()
            .addClass('active');
    }
});



// WEBPACK FOOTER //
// ./app/mpp/views/Main.js